import { Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { AuthService } from "../services/data/auth.service";
import { Claims } from "../types";
import { UnsubscribeOnDestroy } from "../classes";
import { takeUntil } from "rxjs";

@Directive({
    "selector": "[checkAccess]",
    standalone: true
})

export class CheckAccessDirective extends UnsubscribeOnDestroy implements OnInit {
    private templateRef = inject(TemplateRef<any>);
    private viewContainer = inject(ViewContainerRef);
    private authService = inject(AuthService);

    // TODO: Skipped for migration because:
    //  Accessor inputs cannot be migrated as they are too complex.
    @Input() set checkAccess(requiredClaim: Claims) {
        this.requiredClaim = requiredClaim;
    }

    requiredClaim: Claims;
    
    constructor() { super(); }

    ngOnInit() {
        this.authService.hasClaim(this.requiredClaim)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (hasClaim) => {
                    if (hasClaim) {
                        this.viewContainer.createEmbeddedView(this.templateRef);
                    }
                    else {
                        this.viewContainer.clear();
                    }
                }
            );
    }
}